module.exports = __webpack_public_path__ + "c629707b35c6d07c47a957c615fb4413.png";